import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              Kakobuy Spreadsheet Hub
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Your ultimate product discovery database for smart shopping. Curated spreadsheets, QC information, and organized product lists updated daily.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Complete Guide</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Vigorbuy Spreadsheet</Link>
              </li>
              <li>
                <Link to="/qc-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">QC Guide</Link>
              </li>
              <li>
                <Link to="/shopping-safety-guide" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Shopping Safety</Link>
              </li>
              <li>
                <a href="/#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Categories</a>
              </li>
              <li>
                <a href="/#faq" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">FAQ</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Visit Our Platform</h4>
            <p className="text-sm text-foreground-500 mb-4 leading-relaxed">
              Ready to start shopping? Visit our main platform for the full spreadsheet experience.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Go to Main Platform
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Kakobuy Spreadsheet Hub. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            External links open on <strong>kaspreadsheet.com</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}